import * as React from 'react';
import { fetchBuildersInfo } from '../../actions/buildersInfo';
import { setCurrentRegion } from '../../actions/region';
import { setAllFilters } from '../../actions/filters';
import { updatePagination } from '../../actions/pagination';
import { selectRegionByID } from '../../selectors/region';
import { IBrowserHistoryState } from '../../types/browserHistory';
import { IReduxStore, TThunkDispatch } from '../../types/redux';
import { scrollTop } from '../../utils/scroll';
import { getFiltersFromQueryParams, getRegionID } from '../../utils/filters';

export const useLocationChange = (store: IReduxStore) => {
  const dispatch = store.dispatch as TThunkDispatch;

  const getNewFilters = React.useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(searchParams.entries());

    return getFiltersFromQueryParams(params);
  }, []);

  const handleLocationChange = React.useCallback(
    async (event: PopStateEvent) => {
      const state = store.getState();
      const { filters, url } = (event.state as IBrowserHistoryState) || { filters: getNewFilters(), url: '' };
      const regionId = getRegionID(filters);
      const region = selectRegionByID(String(regionId))(state);

      scrollTop();
      dispatch(setAllFilters(filters));
      dispatch(setCurrentRegion(region));
      await dispatch(fetchBuildersInfo(filters, url));
      dispatch(updatePagination());
    },
    [dispatch, store, getNewFilters],
  );

  React.useEffect(() => {
    window.addEventListener('popstate', handleLocationChange);

    return () => window.removeEventListener('popstate', handleLocationChange);
  }, [handleLocationChange]);
};
